import { openDB } from 'idb';

const DB_NAME = 'quikFinDB';
const DB_VERSION = 3;
const DATES_STORE_NAME = 'dateSettings';
export const INVOICE_GRID_SETTINGS = 'invoiceGridSettings';
export const PROJECT_GRID_SETTINGS = 'projectInvoiceGridSettings';

export const initDB = async () => {
	return openDB(DB_NAME, DB_VERSION, {
		upgrade(db) {
			if (!db.objectStoreNames.contains(DATES_STORE_NAME)) {
				db.createObjectStore(DATES_STORE_NAME);
			}
			if (!db.objectStoreNames.contains(INVOICE_GRID_SETTINGS)) {
				db.createObjectStore(INVOICE_GRID_SETTINGS);
			}
			if (!db.objectStoreNames.contains(PROJECT_GRID_SETTINGS)) {
				db.createObjectStore(PROJECT_GRID_SETTINGS);
			}
		},
	});
};

export const saveSelectedDates = async (startDate: string, endDate: string) => {
	const db = await initDB();
	const tx = db.transaction(DATES_STORE_NAME, 'readwrite');
	const store = tx.objectStore(DATES_STORE_NAME);

	await store.put(startDate, 'startDate');
	await store.put(endDate, 'endDate');
	await tx.done;
};

export const getSavedDates = async () => {
	try {
		const db = await initDB();
		const tx = db.transaction(DATES_STORE_NAME);
		const store = tx.objectStore(DATES_STORE_NAME);

		const startDate = await store.get('startDate');
		const endDate = await store.get('endDate');

		if (startDate && endDate) {
			return { startDate, endDate };
		}
		return null;
	} catch (error) {
		console.error('Error loading selected dates:', error);
		return null;
	}
};

export const putStoreValue = async <T>(storeName: string, key: string, value: T) => {
	const db = await initDB();
	const tx = db.transaction(storeName, 'readwrite');
	const store = tx.objectStore(storeName);
	await store.put(value, key);
	await tx.done;
};

export const getStoreValue = async <T>(storeName: string, key: string): Promise<T | null> => {
	try {
		const db = await initDB();
		const tx = db.transaction(storeName);
		const store = tx.objectStore(storeName);
		const value = await store.get(key);
		return value || null;
	} catch (error) {
		console.error(`Error loading ${key}:`, error);
		return null;
	}
};